export const apiEndpoints = {
  GET_STICKY_BUTTON: '/chatbot/sticky-button/detail/',
  LEAD_RECORD: '/chatbot/lead-record/create/',
  UPLOAD_FILE: '/upload-file/',
};
